<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>Szczegóły dotyczące grupy</h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Nazwa grupy:"
            label-for="input-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.group_name"
              type="text"
              required
              placeholder="Wpisz nazwę grupy"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-type"
            label="Typ grupy:"
            label-for="input-type"
            description=""
            class="col-6"
          >
            <b-form-input id="input-type" v-model="form.group_type"></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-api_key"
            label="Lokalizacje, które wchodzą w skład grupy:"
            label-for="input-localizations"
            :description="localizations"
            class="col-6"
          >
            <tags-input
              input-id="input-localizations"
              v-model="form.api_keys"
              :existing-tags="allowedApiKeys"
              :typeahead-hide-discard="true"
              :typeahead="true"
              placeholder="Wpisz nazwę lokalizacji"
              :only-existing-tags="onlyExistingTags"
              :limit="limit"
            >
            </tags-input>
          </b-form-group>
          <h5 class="col-12">Lista powodów wizyt w poszczególnych kategoriach</h5>
          <div class="col-12">
            <b-card no-body>
              <b-tabs card>
                <b-tab active>
                  <template v-slot:title>
                    Wizyta kwalifikacyjna
                    <b-badge variant="dark">{{ form.visit_types.qualification.length }}</b-badge>
                  </template>
                  <b-card-text>
                    <b-input-group prepend="ID powodu wizyty" class="mt-0">
                      <b-form-input
                        v-model="temp"
                        id="input-add-visit-type"
                        type="number"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" @click="addTo('qualification')">Dodaj</b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <h6 class="mt-3">Lista dodanych powodów wizyt</h6>
                    <b-table
                      :items="form.visit_types.qualification"
                      :fields="fields"
                      show-empty
                      empty-text="Brak powodów wizyt"
                      sort-by="IDAnkietaPytanie"
                    >
                      <template v-slot:cell(primary)="row">
                        <b-form-checkbox v-model="row.item.primary"></b-form-checkbox>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <b-button variant="danger" @click="removeFromQualification(row.item)"
                          >Usuń</b-button
                        >
                      </template>
                    </b-table>
                  </b-card-text>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Zabieg <b-badge variant="dark">{{ form.visit_types.surgery.length }}</b-badge>
                  </template>
                  <b-card-text>
                    <b-input-group prepend="ID powodu wizyty" class="mt-0">
                      <b-form-input v-model="temp" type="number"></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" @click="addTo('surgery')">Dodaj</b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <h6 class="mt-3">Lista dodanych powodów wizyt</h6>
                    <b-table
                      :items="form.visit_types.surgery"
                      :fields="fieldsWithoutPrimary"
                      show-empty
                      sort-by="IDAnkietaPytanie"
                      empty-text="Brak powodów wizyt"
                    >
                      <template v-slot:cell(actions)="row">
                        <b-button variant="danger" @click="removeFromSurgery(row.item)"
                          >Usuń</b-button
                        >
                      </template>
                    </b-table>
                  </b-card-text>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Wizyta kontrolna
                    <b-badge variant="dark">{{ form.visit_types.control.length }}</b-badge>
                  </template>
                  <b-card-text>
                    <b-input-group prepend="ID powodu wizyty" class="mt-0">
                      <b-form-input v-model="temp" type="number"></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" @click="addTo('control')">Dodaj</b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <h6 class="mt-3">Lista dodanych powodów wizyt</h6>
                    <b-table
                      :items="form.visit_types.control"
                      :fields="fieldsWithoutPrimary"
                      show-empty
                      sort-by="IDAnkietaPytanie"
                      empty-text="Brak powodów wizyt"
                    >
                      <template v-slot:cell(actions)="row">
                        <b-button variant="danger" @click="removeFromControl(row.item)"
                          >Usuń</b-button
                        >
                      </template>
                    </b-table>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
          <div class="col-12 mt-3 row">
            <div class="col-12">
              <b-button type="submit" variant="primary">Zapisz zmiany</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditVisitTypeGroup',
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    await vm.fetchGroupData()
  },
  data() {
    return {
      temp: null,
      fields: [
        { key: 'primary', label: 'Widoczny w RO' },
        { key: 'IDAnkietaPytanie', label: 'ID powodu wizyty' },
        { key: 'actions', label: '' }
      ],
      fieldsWithoutPrimary: [
        { key: 'IDAnkietaPytanie', label: 'ID powodu wizyty' },
        { key: 'actions', label: '' }
      ],
      form: {
        group_type: null,
        visit_types: {
          qualification: [],
          surgery: [],
          control: []
        },
        api_keys: []
      },
      allowedApiKeys: [],
      onlyExistingTags: true,
      limit: 0,
      localizations: 'Dostępne do wyboru: ',
      types: [{ text: 'Wybierz typ grupy', value: null }, 'zacma', 'laserowa_korekcja']
    }
  },
  methods: {
    async fetchGroupData() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'get-visit-type-group')
      try {
        const response = await vm.$http.post('e-zacma/get-visit-type-group', {
          group_id: vm.$route.params.groupID
        })
        vm.form.group_name = response.data.group_name
        vm.form.group_type = response.data.group_type
        vm.form.api_keys = JSON.parse(response.data.api_keys).map(key => ({
          key,
          value: vm.allowedApiKeys.find(allowedKey => allowedKey.key === key).value
        }))
        vm.form.visit_types = JSON.parse(response.data.data)
        vm.form.group_id = response.data.group_id
      } catch (e) {
        vm.$handleLaravelFormErrorResponse(e)
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'get-visit-type-group')
      }
    },
    onSubmit() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'add-visit-type-group')
      const fromData = { ...vm.form, api_keys: vm.form.api_keys.map(item => item.key) }
      vm.$http
        .post('e-zacma/edit-visit-type-group', fromData)
        .then(() => {
          vm.$toast.success({
            title: 'Sukces',
            message: 'Zmiany zostały zapisane.'
          })
          vm.$router.push({ name: 'e-zacma-visit-types' })
        })
        .catch(e => {
          const { data } = e.response
          if (
            data &&
            data.status &&
            data.message &&
            data.status === 422 &&
            data.message === 'Those api keys are not in same scope'
          ) {
            vm.$error(
              'Podane lokalizacje nie znajdują się w tej samej ogranizacji! Zmień lokalizacje i spróbuj ponownie!',
              'Nie można zapisać powodu wizyty'
            )
          } else {
            vm.$handleLaravelFormErrorResponse(e)
          }
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'add-visit-type-group')
        })
    },
    fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const localizations = response.data
        let i = 0
        // eslint-disable-next-line no-restricted-syntax
        for (const localization of localizations) {
          // eslint-disable-next-line no-plusplus
          ++i
          vm.allowedApiKeys.push({ key: localization.api_key, value: localization.name })
          vm.localizations +=
            localizations.length > i ? `${localization.name}, ` : localization.name
        }
        vm.limit = i
      })
    },
    removeFromQualification(item) {
      this.removeFromArray(this.form.visit_types, 'qualification', item)
    },
    removeFromSurgery(item) {
      this.removeFromArray(this.form.visit_types, 'surgery', item)
    },
    removeFromControl(item) {
      this.removeFromArray(this.form.visit_types, 'control', item)
    },
    removeFromArray($this, stack, needle) {
      $this[stack] = $this[stack].filter(item => item.IDAnkietaPytanie !== needle.IDAnkietaPytanie)
    },
    addTo(type) {
      const vm = this
      // eslint-disable-next-line eqeqeq
      if (vm.form.visit_types[type].filter(item => item.IDAnkietaPytanie == vm.temp).length === 0) {
        vm.form.visit_types[type].push({ IDAnkietaPytanie: vm.temp })
        vm.temp = ''
      }
    }
  }
}
</script>

<style scoped></style>
